import { Button, Add, Box } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import React from "react";
import { NavLink } from "react-router-dom";

function AddButton({ link, onClick }) {
  return (
    <Box
      sx={{
        //border: "1px solid black",
        width: "100%",
        display: "flex",
        justifyContent: "flex-end",
        marginBottom: "5px",
        "& NavLink": {
          textDecoration: "none",
        },
      }}
    >
      {link.href !== null ? (
        <NavLink to={link.href}>
          <Button variant="outlined" startIcon={<AddIcon />} color="primary">
            {link.label}
          </Button>
        </NavLink>
      ) : (
        <Button
          variant="outlined"
          startIcon={<AddIcon />}
          color="primary"
          onClick={onClick}
        >
          {link.label}
        </Button>
      )}
    </Box>
  );
}

export default AddButton;
